import apiService from './api';
import { getCurrentSubdomain } from '../utils/subdomainUtils';

export interface CompanyBySubdomain {
  id: number;
  name: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  website: string;
  logo_url: string;
  subdomain: string;
  is_active: boolean;
}

const subdomainService = {
  /**
   * Get company information by subdomain
   * @param subdomain - The subdomain to look up
   * @returns Company information
   */
  async getCompanyBySubdomain(subdomain: string): Promise<CompanyBySubdomain> {
    console.log("subdomain:::::::", subdomain);
    const response = await apiService.get<CompanyBySubdomain>(`/auth/by-subdomain/${subdomain}`);
    console.log("response123:::::::", response);
    return response.data;
  },

  /**
   * Get company information for the current subdomain
   * @returns Company information for current subdomain
   */
  async getCurrentCompany(): Promise<CompanyBySubdomain | null> {
    try {
      const subdomain = getCurrentSubdomain();
      if (!subdomain) {
        return null;
      }
      return await this.getCompanyBySubdomain(subdomain);
    } catch (error) {
      console.error('Error getting current company:', error);
      return null;
    }
  },

  /**
   * Check if the current subdomain is valid
   * @returns true if subdomain is valid and company exists
   */
  async validateCurrentSubdomain(): Promise<boolean> {
    try {
      const company = await this.getCurrentCompany();
      return company !== null;
    } catch (error) {
      return false;
    }
  }
};

export default subdomainService; 